import React from 'react';

import { PreparePageView } from '@/pages/withdrawal/pages/PreparePage/components';

export const PreparePage: React.FC = () => <PreparePageView />;

export default PreparePage;
